import { Route, Routes } from "react-router-dom";
import { CompanyType } from "../../../types/NendaTypes";
import AssetsPage from "./Pages/Assets";
import Channels from "./Pages/Channels";
import Companies from "./Pages/Companies";
import DailyPlaylists from "./Pages/DailyPlaylists";
import Dashboard from "./Pages/Dashboard";
import Premises from "./Pages/Premises";
import Profile from "./Pages/Profile";
import Promotions from "./Pages/Promotions";
import Users from "./Pages/Users";
import WeeklyPlanner from "./Pages/WeeklyPlanner";
import Contact from "./components/Dashboard/Contact";
import FrontlayerPage from "./Pages/Frontlayer";
import CMS from "./Pages/CMS/CMS";
import Offerings from "./Pages/Offerings/Offerings";
import UnitPage from "./Pages/UnitPage";
import UnitListPage from "./Pages/UnitListPage";
import DigitalSignagePlaylistListPage from "./Pages/DigitalSignagePlaylistListPage";
import DigitalSignagePlaylist from "./Pages/DigitalSignagePlaylist";
import Groups from "./Pages/Groups";
import Group from "./Pages/Group";
import ContentChannels from "./Pages/ContentChannel/ContentChannels";
import ContentChannel from "./Pages/ContentChannel/ContentChannel";

const Main = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="dashboard">
        <Route path=":type/:id" element={<Dashboard />} />
      </Route>
      <Route path="/premise/:premiseId/units" element={<UnitListPage />} />
      <Route path="/premise/:premiseId/unit/:unitId" element={<UnitPage />} />
      <Route path="/premises/company/:id" element={<Premises />} />
      <Route
        path="/premise/:premiseId/digital-signage-playlists/create"
        element={<DigitalSignagePlaylist create />}
      />
      <Route
        path="/company/:companyId/digital-signage-playlists/create"
        element={<DigitalSignagePlaylist create />}
      />
      <Route
        path="/premise/:premiseId/digital-signage-playlists/:playlistId"
        element={<DigitalSignagePlaylist />}
      />
      <Route
        path="/premise/:premiseId/digital-signage-playlists"
        element={<DigitalSignagePlaylistListPage />}
      />
      <Route
        path="/company/:companyId/digital-signage-playlists/create"
        element={<DigitalSignagePlaylist />}
      />
      <Route
        path="/company/:companyId/digital-signage-playlists/:playlistId"
        element={<DigitalSignagePlaylist />}
      />
      <Route
        path="/company/:companyId/digital-signage-playlists"
        element={<DigitalSignagePlaylistListPage />}
      />

      <Route path="/frontlayer/premise/:id" element={<FrontlayerPage />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="admin">
        <Route path="companies" element={<Companies />}>
          {Object.values(CompanyType).map((type) => (
            <Route key={type} path={type} element={<Companies />} />
          ))}
        </Route>
        <Route path="premiselist" element={<Premises />} />
        <Route path="metadata/*" element={<CMS />}></Route>
        <Route path="offerings/*" element={<Offerings />}></Route>
        <Route path="content" element={<ContentChannels />} />
        <Route path="content/:channelId" element={<ContentChannel />} />
      </Route>
      <Route path="channels/:type/:id" element={<Channels />} />

      <Route
        path="scheduling/schedule/premise/:id"
        element={<WeeklyPlanner />}
      />
      <Route
        path="scheduling/daily-playlists/premise/:id"
        element={<DailyPlaylists />}
      />
      <Route
        path="scheduling/schedule/company/:id"
        element={<WeeklyPlanner />}
      />
      <Route
        path="scheduling/daily-playlists/company/:id"
        element={<DailyPlaylists />}
      />
      <Route path="/users" element={<Users />} />
      <Route path="promotions">
        <Route path=":type/:id" element={<Promotions />} />
      </Route>
      <Route path="media-library">
        <Route path=":type/:id" element={<AssetsPage />} />
      </Route>

      <Route path="company/:parentId/groups" element={<Groups />} />
      <Route path="premise/:parentId/groups" element={<Groups />} />
      <Route path="company/:parentId/group/:groupId" element={<Group />} />
      <Route path="premise/:parentId/group/:groupId" element={<Group />} />

      <Route path="contact" element={<Contact />}>
        <Route path=":type/:tid" element={<Contact />} />
      </Route>
    </Routes>
  );
};

export default Main;
